import type { HttpClient } from '@/lib/http/client.js'
import type { CreatePlanInput, Plan, UpdatePlanInput } from '@/types/plan/plan.type.js'

/** `admin/plans`, verified against `plan-admin.controller.ts`. Ids are integers. */
export interface PlanService {
  list: () => Promise<readonly Plan[]>
  get: (id: number) => Promise<Plan>
  create: (input: CreatePlanInput) => Promise<Plan>
  update: (id: number, input: UpdatePlanInput) => Promise<Plan>
  /** 204. Refused while any subscription names the plan's slug. */
  remove: (id: number) => Promise<void>
}

export function createPlanService(http: HttpClient): PlanService {
  return {
    list: () => http.get<readonly Plan[]>('admin/plans'),
    get: (id) => http.get<Plan>(`admin/plans/${String(id)}`),
    create: (input) => http.post<Plan>('admin/plans', input),
    update: (id, input) => http.patch<Plan>(`admin/plans/${String(id)}`, input),
    remove: async (id) => {
      await http.delete(`admin/plans/${String(id)}`)
    },
  }
}
